import { Component, EventEmitter, Inject, Injector, Output } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { SeaModel } from "../../models/sea/sea-model";
import { MarketSeaProductsModel } from "../../models/sea/market-sea-products.model";
import { ChangeLanguageService } from 'src/app/services/change-language.service';
import { SeaComponent } from 'src/app/pages/sea/sea.component';
import { SeaSearchService } from 'src/app/services/sea/sea-search.service';
import { BaseFormComponentComponent } from 'src/app/shared/base-form-component/base-form-component.component';
import { UserModel } from 'src/app/models/auth/user.model';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-air-price-request-dialog',
  templateUrl: './air-price-request-dialog.component.html',
  styleUrls: ['./air-price-request-dialog.component.scss']
})
export class AirPriceRequestDialogComponent  extends BaseFormComponentComponent {
  readonly MAX_SELECTED = 4;
  product: MarketSeaProductsModel = null;
  model: SeaModel = null;
  lang: string = "tr";
  surchargeDialogRef: DynamicDialogRef;
  parent: SeaComponent = null;
  loading: boolean = false;
  showButton: boolean = false;
  user: UserModel = null;

  constructor(protected injector: Injector,public config: DynamicDialogConfig, public ref: DynamicDialogRef, 
    public dialogService: DialogService, private languageService: ChangeLanguageService, private userService: UserService
  ) {
    super(injector)
    this.product = this.config.data.product;
    this.model = this.config.data.model;
    this.lang = this.languageService.getCurrentLanguage();
    this.parent = this.config.data.parentComponent;
    this.showButton = this.config.data.showButton;

    this.product.selected = true;


  }


  closeDialog() {
    this.ref.close();
  }

  onSelectPriceRequestRow(product: MarketSeaProductsModel) {
    product.selected = !product.selected;
  }

  hasSelectedProduct() {
    return this.model.products.filter(f => f.selected).length > 0
  }

  async makeReservation() {
    this.loading = true;

    const selectedProducts = this.model.products.filter(f => f.selected);
    this.user = await this.userService.user().toPromise();
    const approveMessage = await this.translation.get('approveMessageLabel').toPromise();
    if(this.user.status != 'AP') {
        this.messageService.add({severity: 'warn', key: 'html-msg', summary: '', detail: approveMessage});
        this.loading = false;
        return;
    }
    
    if(selectedProducts.length > 0) {
      this.ref.close({ products: selectedProducts[0] });
    } else {
          this.ref.close();
    }
    this.loading = false;
  }

  onCheckboxChange(event: any, product: any) {
    const isChecked = event.checked;

    if (isChecked) {
      const selectedCount = this.model.products.filter(p => p.selected).length;

      if (selectedCount >= this.MAX_SELECTED) {

        setTimeout(() => {
          product.selected = false;
        }, 0);

          this.showMessageStickly('warn', 'maxSelectedProductLimit')
        
        return;
      }

      product.selected = true;
    } else {
      product.selected = false;
    }
  }

}
